import validateConfiguration from "./validateConfiguration";
import validateContext from "./validateContext";

const validateParams = ({ context, configuration }) => {
  validateContext(context);
  validateConfiguration(configuration);
};

export default validateParams;
